import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

interface IApiResponseFederatedLogin {
  federatedToken: string;
}

export const federatedBflWebLogin = async (
  mobileNo: string,
  clientId: string,
  clientSecret: string
): Promise<IResponse<IApiResponseFederatedLogin>> => {
  const response = await encryptedRequest<IApiResponseFederatedLogin>({
    method: "POST",
    url: API_PATHS.federatedBflWebLogin,
    data: { mobileNo, clientId, clientSecret },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const federatedBflWebAuthorize = async (
  mobileNo: string,
  federatedToken: string,
  clientId: string
): Promise<IResponse<null>> => {
  const response = await encryptedRequest<null>({
    method: "POST",
    url: API_PATHS.federatedBflWebAuthorize,
    data: { mobileNo, federatedToken, clientId },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
